/* eslint-disable class-methods-use-this */
import { EntityDto, PagedResultDto } from 'services/dto';
import http from '../httpService';
import {
  CreateServiceHistory,
  LogVehicleSearchInput,
  PagedServiceHistory,
  SearchServiceHistoryInput,
  ServiceHistory,
  ServiceHistoryDetails,
  ServiceHistoryListItem,
  UpdateServiceHistory,
  VehicleHistorySearch,
} from './dto';

class ServiceHistoryService {
  public async getAll(request: PagedServiceHistory): Promise<PagedResultDto<ServiceHistory>> {
    const result = await http.get('api/services/app/ServiceHistory/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto<string>): Promise<ServiceHistory> {
    const result = await http.get('api/services/app/ServiceHistory/Get', { params: entityDto });
    return result.data.result;
  }

  public async create(request: CreateServiceHistory): Promise<ServiceHistory> {
    const result = await http.post('api/services/app/ServiceHistory/Create', request);
    return result.data.result;
  }

  public async update(request: UpdateServiceHistory): Promise<ServiceHistory> {
    const result = await http.put('api/services/app/ServiceHistory/Update', request);
    return result.data.result;
  }

  public async sendServiceHistoryEmail(vin: string, email?: string, fullName?: string, statuses?: string[]): Promise<void> {
    await http.post('api/services/app/ServiceHistory/SendServiceHistoryEmail', { vin, email, fullName, statuses });
  }

  public async search(
    request: SearchServiceHistoryInput,
  ): Promise<PagedResultDto<ServiceHistoryListItem>> {
    const result = await http.get('api/services/app/ServiceHistory/Search', {
      params: request,
    });
    return result.data.result;
  }

  public async getDetails(id: string): Promise<ServiceHistoryDetails> {
    const result = await http.get('api/services/app/ServiceHistory/GetDetails', {
      params: { id },
    });
    return result.data.result;
  }

  public async getRecentSearches(): Promise<VehicleHistorySearch[]> {
    const result = await http.get('api/services/app/ServiceHistory/GetRecentSearches');
    return result.data.result;
  }

  public async logSearch(input: LogVehicleSearchInput): Promise<void> {
    await http.post('api/services/app/ServiceHistory/LogSearch', input);
  }
}

export default new ServiceHistoryService();
